import React from 'react';
import './NotFound.css'
const NotFound = () => {
    return (
        <div className="notfound-container">
            <h1>404</h1>
            <h5>Page Not Found</h5>
            <h6>Check The Url Or Try Again Later</h6>
        </div>
    );
};

export default NotFound;